import {
  mediaFragment,
  responsiveMediaFragment
} from '~/gql/mediaFragments.gql'

export const getScenePreviews = scenes => `query {
  allLensGuideScenes(filter: {sceneName: {in: ${scenes}}}) {
    sceneName
    ${mediaFragment('nakedEyeImage', '{ w: "96", h: "96" }')}
  }
}`

export const getScene = scene => `query {
  lensGuideScene(filter: {sceneName: {matches: {pattern: "${scene}"}}}) {
    sceneName
    ${responsiveMediaFragment('nakedEyeImage', '{ w: "1400", h: "1400" }')}
    sceneImages {
      lensType
      lensColour
      ${responsiveMediaFragment('image', '{ w: "1400", h: "1400" }')}
      ${responsiveMediaFragment('secondaryImage', '{ w: "1400", h: "1400" }')}
    }
  }
}`

export const getAllScenes = scenes => `query {
  allLensGuideScenes(filter: {sceneName: {in: ${scenes}}}) {
    sceneName
    ${responsiveMediaFragment('nakedEyeImage', '{ w: "1400", h: "1400" }')}
    sceneImages {
      lensType
      lensColour
      ${responsiveMediaFragment('image', '{ w: "1400", h: "1400" }')}
      ${responsiveMediaFragment('secondaryImage', '{ w: "1400", h: "1400" }')}
    }
  }
}`
